import { createSelector } from 'reselect';

import getLocation from './getLocation';

export default createSelector(
  [getLocation],
  location => location?.cutoffTresholds,
);
